// Number and date helpers for the Push review. Dates are ISO yyyy-mm-dd
// strings handled in UTC, so no time zone shifts a day.

export function num(value: number) {
  return value.toLocaleString("en-US")
}

// Units per day with one decimal; a pace above zero but under 0.1 shows as
// "< 0.1" so it never reads as no movement.
export function perDay(value: number) {
  if (value > 0 && value < 0.05) return "< 0.1"
  return value.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
}

function formatDate(iso: string, options: Intl.DateTimeFormatOptions) {
  return new Date(iso + "T00:00:00Z").toLocaleDateString("en-US", { ...options, timeZone: "UTC" })
}

export const shortDate = (iso: string) => formatDate(iso, { month: "short", day: "numeric" })
export const fullDate = (iso: string) => formatDate(iso, { month: "short", day: "numeric", year: "numeric" })
